import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAccountLastContactedTime as GetAccountLastContactedTimeQuery,
    GetAccountLastContactedTimeVariables,
    AccountLastContactedTimeFragment,
} from 'nutshell-graphql-types';

import GET_ACCOUNT_LAST_CONTACTED_TIME from '../queries/get-account-last-contacted-time.graphql';

export function useGetAccountLastContactedTime(accountId: string): {
    accountLastContact: AccountLastContactedTimeFragment | null;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, loading, error, refetch} = useQuery<
        GetAccountLastContactedTimeQuery,
        GetAccountLastContactedTimeVariables
    >(GET_ACCOUNT_LAST_CONTACTED_TIME, {
        variables: {id: accountId},
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
    });

    return {
        accountLastContact: data?.account ?? null,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
